import { observable, computed, action } from "mobx";
import api from "../api";
import ICourse, { ICourseData } from "../typings/ICourse";
import { ICoursesGroup, TGroupType } from "../typings/ICourseGroup";

export default class CoursesListStore<T extends ICourse> {
  @observable rootStore: any;
  constructor(rootStore?: any) {
    this.rootStore = rootStore;
    this.page = 1;
    this.groups = [];
    this.isLoading = false;

    this.groupsLimit = 5;
  }

  @observable page: number;
  @observable groups: Array<CoursesGroup<T>>;
  @observable isLoading: boolean;
  @observable isLoadingNext: boolean;
  @observable pageCount: number;

  @observable
  error: string | boolean;

  groupsLimit: number;
  group: number;
  @computed
  get hasMoreGroups() {
    if (!this.pageCount) {
      return false;
    }
    return this.page <= this.pageCount;
  }

  @action
  async getGroupsList(next?: boolean) {
    try {
      this.isLoading = next ? false : true;
      const res = await api.coursesGroups.byAuthor({
        limit: this.groupsLimit,
        page: this.page,
      });
      this.pageCount = res.paginator.pageCount;
      for (let group of res.data) {
        const courseGroup = new CoursesGroup(group);
        await courseGroup.getCourses();
        this.groups.push(courseGroup);
      }

      this.isLoading = false;
    } catch (error) {
      this.error = true;
    }

  }

  async getGroupsNext() {
    if (this.isLoadingNext) return;
    this.isLoadingNext = true;
    this.page = this.page + 1;
    await this.getGroupsList(true);
    this.isLoadingNext = false;
  }
}

export class CoursesGroup<T extends ICourse> implements ICoursesGroup<T> {
  id: number;
  icon: string;
  name: string;
  title?: string;
  author?: string;
  @observable
  courses: T[];
  @observable
  count: number;
  @observable
  page?: number;
  @observable
  pageCount?: number;

  @observable
  hasMoreCourses?: boolean;

  @observable
  extended?: boolean;

  PER_PAGE: number;

  @observable
  loading: boolean;
  @observable
  loadingNext: boolean;

  @observable
  buyLink?: string;

  @observable
  groupType: TGroupType;
  @observable
  description: string;
  subtitle: string;
  salepage: string;

  constructor(group: ICoursesGroup<T>) {
    this.id = group.id;
    this.groupType = group.groupType;
    this.icon = group.icon;
    this.name = group.name;
    this.author = group.author;
    this.courses = group.courses || [];
    this.count = group.count;
    this.loadingNext = false;
    this.page = 1;
    this.PER_PAGE = 12;
    this.buyLink = group.buyLink;
  }



  @action
  async getCourses(next?: boolean, params?: {search?: string, atpay?: boolean, onlyAuthor?: boolean}) {
    this.loading = next ? false : true;
    const resp = await api.courses.coursesByGroup({
      ...params,
      group_id: this.id,
      limit: this.PER_PAGE,
      page: this.page,
    });
    this.courses.push(...(resp as unknown as Array<T>));
    this.hasMoreCourses = !(resp.length < this.PER_PAGE);
    this.loading = false;
  }

  @action
  async getMoreCourses() {
    if (this.loadingNext) return;
    this.loadingNext = true;
    this.page = this.page + 1;
    await this.getCourses(true)
    this.loadingNext = false;
  }

}
